import { render, staticRenderFns } from "./VehicleNav.vue?vue&type=template&id=4f404556&scoped=true&"
import script from "./VehicleNav.vue?vue&type=script&lang=js&"
export * from "./VehicleNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f404556",
  null
  
)

export default component.exports